import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
// import reportWebVitals from './reportWebVitals';

import { I18nextProvider } from "react-i18next"
import i18next from "i18next";

import global_es from "./translations/es/global.json"
import global_en from "./translations/en/global.json"
import global_ca from "./translations/ca/global.json"
import global_eu from "./translations/eu/global.json"
import global_fr from "./translations/fr/global.json"
import global_gl from "./translations/gl/global.json"
import global_va from "./translations/va/global.json"

import header_es from "./translations/es/header.json";
import header_en from "./translations/en/header.json";
import header_ca from "./translations/ca/header.json";
import header_eu from "./translations/eu/header.json";
import header_fr from "./translations/fr/header.json";
import header_gl from "./translations/gl/header.json";
import header_va from "./translations/va/header.json";


import resumeroute_es from "./translations/es/resumeroute.json";
import resumeroute_en from "./translations/en/resumeroute.json";
import resumeroute_ca from "./translations/ca/resumeroute.json";
import resumeroute_eu from "./translations/eu/resumeroute.json";
import resumeroute_fr from "./translations/fr/resumeroute.json";
import resumeroute_gl from "./translations/gl/resumeroute.json";
import resumeroute_va from "./translations/va/resumeroute.json";

import home_es from "./translations/es/public/home.json";
import home_en from "./translations/en/public/home.json";
import home_ca from "./translations/ca/public/home.json";
import home_eu from "./translations/eu/public/home.json";
import home_fr from "./translations/fr/public/home.json";
import home_gl from "./translations/gl/public/home.json";
import home_va from "./translations/va/public/home.json";

import registerflow_es from "./translations/es/public/registerflow.json";
import registerflow_en from "./translations/en/public/registerflow.json";
import registerflow_ca from "./translations/ca/public/registerflow.json";
import registerflow_eu from "./translations/eu/public/registerflow.json";
import registerflow_fr from "./translations/fr/public/registerflow.json";
import registerflow_gl from "./translations/gl/public/registerflow.json";
import registerflow_va from "./translations/va/public/registerflow.json";

import login_es from "./translations/es/public/login.json";
import login_en from "./translations/en/public/login.json";
import login_ca from "./translations/ca/public/login.json";
import login_eu from "./translations/eu/public/login.json";
import login_fr from "./translations/fr/public/login.json";
import login_gl from "./translations/gl/public/login.json";
import login_va from "./translations/va/public/login.json";

import recoverPasswordFlow_es from "./translations/es/public/recoverPasswordFlow.json";
import recoverPasswordFlow_en from "./translations/en/public/recoverPasswordFlow.json";
import recoverPasswordFlow_ca from "./translations/ca/public/recoverPasswordFlow.json";
import recoverPasswordFlow_eu from "./translations/eu/public/recoverPasswordFlow.json";
import recoverPasswordFlow_fr from "./translations/fr/public/recoverPasswordFlow.json";
import recoverPasswordFlow_gl from "./translations/gl/public/recoverPasswordFlow.json";
import recoverPasswordFlow_va from "./translations/va/public/recoverPasswordFlow.json";

import aveFlow_es from "./translations/es/private/aveFlow.json";
import aveFlow_en from "./translations/en/private/aveFlow.json";
import aveFlow_ca from "./translations/ca/private/aveFlow.json";
import aveFlow_eu from "./translations/eu/private/aveFlow.json";
import aveFlow_fr from "./translations/fr/private/aveFlow.json";
import aveFlow_gl from "./translations/gl/private/aveFlow.json";
import aveFlow_va from "./translations/va/private/aveFlow.json";

import confirmPlani_es from "./translations/es/private/confirmPlani.json";
import confirmPlani_en from "./translations/en/private/confirmPlani.json";
import confirmPlani_ca from "./translations/ca/private/confirmPlani.json";
import confirmPlani_eu from "./translations/eu/private/confirmPlani.json";
import confirmPlani_fr from "./translations/fr/private/confirmPlani.json";
import confirmPlani_gl from "./translations/gl/private/confirmPlani.json";
import confirmPlani_va from "./translations/va/private/confirmPlani.json";

import  myPastTrips_es  from './translations/es/private/myPastTrips.json';
import  myPastTrips_en  from './translations/en/private/myPastTrips.json';
import  myPastTrips_ca  from './translations/ca/private/myPastTrips.json';
import  myPastTrips_eu  from './translations/eu/private/myPastTrips.json';
import  myPastTrips_fr  from './translations/fr/private/myPastTrips.json';
import  myPastTrips_gl  from './translations/gl/private/myPastTrips.json';
import  myPastTrips_va  from './translations/va/private/myPastTrips.json';

import  myTrips_es  from './translations/es/private/myTrips.json';
import  myTrips_en  from './translations/en/private/myTrips.json';
import  myTrips_ca  from './translations/ca/private/myTrips.json';
import  myTrips_eu  from './translations/eu/private/myTrips.json';
import  myTrips_fr  from './translations/fr/private/myTrips.json';
import  myTrips_gl  from './translations/gl/private/myTrips.json';
import  myTrips_va  from './translations/va/private/myTrips.json';

import onBoarding_es from './translations/es/private/onBoarding.json';
import onBoarding_en from './translations/en/private/onBoarding.json';
import onBoarding_ca from './translations/ca/private/onBoarding.json';
import onBoarding_eu from './translations/eu/private/onBoarding.json';
import onBoarding_fr from './translations/fr/private/onBoarding.json';
import onBoarding_gl from './translations/gl/private/onBoarding.json';
import onBoarding_va from './translations/va/private/onBoarding.json';

import onBoardingATC_es from './translations/es/private/onBoardingATC.json';
import onBoardingATC_en from './translations/en/private/onBoardingATC.json';
import onBoardingATC_ca from './translations/ca/private/onBoardingATC.json';
import onBoardingATC_eu from './translations/eu/private/onBoardingATC.json';
import onBoardingATC_fr from './translations/fr/private/onBoardingATC.json';
import onBoardingATC_gl from './translations/gl/private/onBoardingATC.json';
import onBoardingATC_va from './translations/va/private/onBoardingATC.json';

import paymentMethodsFlow_es from './translations/es/private/paymentMethodsFlow.json';
import paymentMethodsFlow_en from './translations/en/private/paymentMethodsFlow.json';
import paymentMethodsFlow_ca from './translations/ca/private/paymentMethodsFlow.json';
import paymentMethodsFlow_eu from './translations/eu/private/paymentMethodsFlow.json';
import paymentMethodsFlow_fr from './translations/fr/private/paymentMethodsFlow.json';
import paymentMethodsFlow_gl from './translations/gl/private/paymentMethodsFlow.json';
import paymentMethodsFlow_va from './translations/va/private/paymentMethodsFlow.json';

import personalDataProfile_es from './translations/es/private/personalDataProfile.json';
import personalDataProfile_en from './translations/en/private/personalDataProfile.json';
import personalDataProfile_ca from './translations/ca/private/personalDataProfile.json';
import personalDataProfile_eu from './translations/eu/private/personalDataProfile.json';
import personalDataProfile_fr from './translations/fr/private/personalDataProfile.json';
import personalDataProfile_gl from './translations/gl/private/personalDataProfile.json';
import personalDataProfile_va from './translations/va/private/personalDataProfile.json';

import preferences_es from './translations/es/private/preferences.json';
import preferences_en from './translations/en/private/preferences.json';
import preferences_ca from './translations/ca/private/preferences.json';
import preferences_eu from './translations/eu/private/preferences.json';
import preferences_fr from './translations/fr/private/preferences.json';
import preferences_gl from './translations/gl/private/preferences.json';
import preferences_va from './translations/va/private/preferences.json';

import privateHome_es from './translations/es/private/privateHome.json';
import privateHome_en from './translations/en/private/privateHome.json';
import privateHome_ca from './translations/ca/private/privateHome.json';
import privateHome_eu from './translations/eu/private/privateHome.json';
import privateHome_fr from './translations/fr/private/privateHome.json';
import privateHome_gl from './translations/gl/private/privateHome.json';
import privateHome_va from './translations/va/private/privateHome.json';

import tripSelector_es from './translations/es/private/tripSelector.json';
import tripSelector_en from './translations/en/private/tripSelector.json';
import tripSelector_ca from './translations/ca/private/tripSelector.json';
import tripSelector_eu from './translations/eu/private/tripSelector.json';
import tripSelector_fr from './translations/fr/private/tripSelector.json';
import tripSelector_gl from './translations/gl/private/tripSelector.json';
import tripSelector_va from './translations/va/private/tripSelector.json';

import plannerFlow_es from './translations/es/public/plannerFlow.json';
import plannerFlow_en from './translations/en/public/plannerFlow.json';
import plannerFlow_ca from './translations/ca/public/plannerFlow.json';
import plannerFlow_eu from './translations/eu/public/plannerFlow.json';
import plannerFlow_fr from './translations/fr/public/plannerFlow.json';
import plannerFlow_gl from './translations/gl/public/plannerFlow.json';
import plannerFlow_va from './translations/va/public/plannerFlow.json';

import assint_es from './translations/es/assist.json';
import assint_en from './translations/en/assist.json';
import assint_ca from './translations/ca/assist.json';
import assint_eu from './translations/eu/assist.json';
import assint_fr from './translations/fr/assist.json';
import assint_gl from './translations/gl/assist.json';
import assint_va from './translations/va/assist.json';


import deleteAccountFlow_es from './translations/es/private/deleteAccountFlow.json';
import deleteAccountFlow_en from './translations/en/private/deleteAccountFlow.json';
import deleteAccountFlow_ca from './translations/ca/private/deleteAccountFlow.json';
import deleteAccountFlow_eu from './translations/eu/private/deleteAccountFlow.json';
import deleteAccountFlow_fr from './translations/fr/private/deleteAccountFlow.json';
import deleteAccountFlow_gl from './translations/gl/private/deleteAccountFlow.json';
import deleteAccountFlow_va from './translations/va/private/deleteAccountFlow.json';

import userform_es from './translations/es/public/userform.json';
import userform_en from './translations/en/public/userform.json';
import userform_ca from './translations/ca/public/userform.json';
import userform_eu from './translations/eu/public/userform.json';
import userform_fr from './translations/fr/public/userform.json';
import userform_gl from './translations/gl/public/userform.json';
import userform_va from './translations/va/public/userform.json';

import myCardTitles_es from './translations/es/private/myCardsTitles.json'
import myCardTitles_en from './translations/en/private/myCardsTitles.json'
import myCardTitles_ca from './translations/ca/private/myCardsTitles.json'
import myCardTitles_eu from './translations/eu/private/myCardsTitles.json'
import myCardTitles_fr from './translations/fr/private/myCardsTitles.json'
import myCardTitles_gl from './translations/gl/private/myCardsTitles.json'
import myCardTitles_va from './translations/va/private/myCardsTitles.json'

import tmbpages_es from './translations/es/public/tmbPages.json'
import tmbpages_en from './translations/en/public/tmbPages.json'
import tmbpages_ca from './translations/ca/public/tmbPages.json'
import tmbpages_eu from './translations/eu/public/tmbPages.json'
import tmbpages_fr from './translations/fr/public/tmbPages.json'
import tmbpages_gl from './translations/gl/public/tmbPages.json'
import tmbpages_va from './translations/va/public/tmbPages.json'

import tmbModals_es from './translations/es/public/tmbModals.json'
import tmbModals_en from './translations/en/public/tmbModals.json'
import tmbModals_ca from './translations/ca/public/tmbModals.json'
import tmbModals_eu from './translations/eu/public/tmbModals.json'
import tmbModals_fr from './translations/fr/public/tmbModals.json'
import tmbModals_gl from './translations/gl/public/tmbModals.json'
import tmbModals_va from './translations/va/public/tmbModals.json'

import discountModals_es from './translations/es/private/discountModals.json'
import discountModals_en from './translations/en/private/discountModals.json'
import discountModals_ca from './translations/ca/private/discountModals.json'
import discountModals_eu from './translations/eu/private/discountModals.json'
import discountModals_fr from './translations/fr/private/discountModals.json'
import discountModals_gl from './translations/gl/private/discountModals.json'
import discountModals_va from './translations/va/private/discountModals.json'

import tmbConfirmPlanni_es from './translations/es/private/tmbConfirmPlanni.json'
import tmbConfirmPlanni_ca from './translations/ca/private/tmbConfirmPlanni.json'
import tmbConfirmPlanni_en from './translations/en/private/tmbConfirmPlanni.json'
import tmbConfirmPlanni_va from './translations/va/private/tmbConfirmPlanni.json'
import tmbConfirmPlanni_gl from './translations/gl/private/tmbConfirmPlanni.json'
import tmbConfirmPlanni_fr from './translations/fr/private/tmbConfirmPlanni.json'
import tmbConfirmPlanni_eu from './translations/eu/private/tmbConfirmPlanni.json'

import trainPlannerFlow_es from './translations/es/public/trainPlannerFlow.json';
import trainPlannerFlow_ca from './translations/ca/public/trainPlannerFlow.json';
import trainPlannerFlow_en from './translations/en/public/trainPlannerFlow.json';
import trainPlannerFlow_va from './translations/va/public/trainPlannerFlow.json';
import trainPlannerFlow_gl from './translations/gl/public/trainPlannerFlow.json';
import trainPlannerFlow_fr from './translations/fr/public/trainPlannerFlow.json';
import trainPlannerFlow_eu from './translations/eu/public/trainPlannerFlow.json';

import sixtFlow_es from './translations/es/private/sixtFlow.json'
import sixtFlow_en from './translations/en/private/sixtFlow.json'
import sixtFlow_ca from './translations/ca/private/sixtFlow.json'
import sixtFlow_eu from './translations/eu/private/sixtFlow.json'
import sixtFlow_fr from './translations/fr/private/sixtFlow.json'
import sixtFlow_gl from './translations/gl/private/sixtFlow.json'
import sixtFlow_va from './translations/va/private/sixtFlow.json'

import sixtModals_es from './translations/es/private/sixtModals.json'
import sixtModals_en from './translations/en/private/sixtModals.json'
import sixtModals_ca from './translations/ca/private/sixtModals.json'
import sixtModals_eu from './translations/eu/private/sixtModals.json'
import sixtModals_fr from './translations/fr/private/sixtModals.json'
import sixtModals_gl from './translations/gl/private/sixtModals.json'
import sixtModals_va from './translations/va/private/sixtModals.json'



import myPoints_es from './translations/es/private/myPoints.json'
import myPoints_en from './translations/en/private/myPoints.json'
import myPoints_ca from './translations/ca/private/myPoints.json'
import myPoints_eu from './translations/eu/private/myPoints.json'
import myPoints_fr from './translations/fr/private/myPoints.json'
import myPoints_gl from './translations/gl/private/myPoints.json'
import myPoints_va from './translations/va/private/myPoints.json'

// import {  } from "raas-util-library";

//Contexts
import { RaaSContextProvider } from 'contexts/global.context';

i18next.init({
  lng: sessionStorage['raas-language'] || "es",
  interpolation: { escapeValue: false },
  resources: {
    es: {
      global: global_es,
      home: home_es,
      header: header_es,
      resumeroute: resumeroute_es,
      registerflow: registerflow_es,
      login:login_es,
      recoverPasswordFlow:recoverPasswordFlow_es,
      aveFlow:aveFlow_es,
      confirmPlani:confirmPlani_es,
      myPastTrips:myPastTrips_es,
      myTrips:myTrips_es,
      onBoarding:onBoarding_es,
      onBoardingATC:onBoardingATC_es,
      paymentMethodsFlow:paymentMethodsFlow_es,
      personalDataProfile:personalDataProfile_es,
      preferences:preferences_es,
      privateHome:privateHome_es,
      tripSelector:tripSelector_es,
      plannerFlow:plannerFlow_es,
      assint:assint_es,
      deleteAccountFlow:deleteAccountFlow_es,
      userform:userform_es,
      myCardsTitles:myCardTitles_es,
      tmbPages:tmbpages_es,
      tmbConfirmPlanni:tmbConfirmPlanni_es,
      tmbModals:tmbModals_es,
      discountModals:discountModals_es,
      trainPlannerFlow:trainPlannerFlow_es,
      sixtFlow:sixtFlow_es,
      sixtModals:sixtModals_es,
      myPoints:myPoints_es
    },
    en: {
      global: global_en,
      home: home_en,
      header: header_en,
      resumeroute: resumeroute_en,
      registerflow: registerflow_en,
      login:login_en,
      recoverPasswordFlow:recoverPasswordFlow_en,
      aveFlow:aveFlow_en,
      confirmPlani:confirmPlani_en,
      myPastTrips:myPastTrips_en,
      myTrips:myTrips_en,
      onBoarding:onBoarding_en,
      onBoardingATC:onBoardingATC_en,
      paymentMethodsFlow:paymentMethodsFlow_en,
      personalDataProfile:personalDataProfile_en,
      preferences:preferences_en,
      privateHome:privateHome_en,
      tripSelector:tripSelector_en,
      plannerFlow:plannerFlow_en,
      assint:assint_en,
      deleteAccountFlow:deleteAccountFlow_en,
      userform:userform_en,
      myCardsTitles:myCardTitles_en,
      tmbPages:tmbpages_en,
      tmbConfirmPlanni:tmbConfirmPlanni_en,
      tmbModals:tmbModals_en,
      sixtFlow:sixtFlow_en,
      sixtModals:sixtModals_en,
      discountModals:discountModals_en,
      myPoints: myPoints_en,
      trainPlannerFlow:trainPlannerFlow_en

    },
    eu: {
      global: global_eu,
      home: home_eu,
      header: header_eu,
      resumeroute: resumeroute_eu,
      registerflow: registerflow_eu,
      login:login_eu,
      recoverPasswordFlow:recoverPasswordFlow_eu,
      aveFlow:aveFlow_eu,
      confirmPlani:confirmPlani_eu,
      myPastTrips:myPastTrips_eu,
      myTrips:myTrips_eu,
      onBoarding:onBoarding_eu,
      onBoardingATC:onBoardingATC_eu,
      paymentMethodsFlow:paymentMethodsFlow_eu,
      personalDataProfile:personalDataProfile_eu,
      preferences:preferences_eu,
      privateHome:privateHome_eu,
      tripSelector:tripSelector_eu,
      plannerFlow:plannerFlow_eu,
      assint:assint_eu,
      deleteAccountFlow:deleteAccountFlow_eu,
      userform:userform_eu,
      myCardsTitles:myCardTitles_eu,
      tmbPages:tmbpages_eu,
      tmbModals:tmbModals_eu,
      tmbConfirmPlanni:tmbConfirmPlanni_eu,
      sixtFlow:sixtFlow_eu,
      sixtModals:sixtModals_eu,
      discountModals:discountModals_eu,
      myPoints: myPoints_eu,
      trainPlannerFlow:trainPlannerFlow_eu
      
    },
    ca: {
      global: global_ca,
      home: home_ca,
      header: header_ca,
      resumeroute: resumeroute_ca,
      registerflow: registerflow_ca,
      login:login_ca,
      recoverPasswordFlow:recoverPasswordFlow_ca,
      aveFlow:aveFlow_ca,
      confirmPlani:confirmPlani_ca,
      myPastTrips:myPastTrips_ca,
      myTrips:myTrips_ca,
      onBoarding:onBoarding_ca,
      onBoardingATC:onBoardingATC_ca,
      paymentMethodsFlow:paymentMethodsFlow_ca,
      personalDataProfile:personalDataProfile_ca,
      preferences:preferences_ca,
      privateHome:privateHome_ca,
      tripSelector:tripSelector_ca,
      plannerFlow:plannerFlow_ca,
      assint:assint_ca,
      deleteAccountFlow:deleteAccountFlow_ca,
      userform:userform_ca,
      myCardsTitles:myCardTitles_ca,
      tmbPages:tmbpages_ca,
      tmbConfirmPlanni:tmbConfirmPlanni_ca,
      tmbModals:tmbModals_ca,
      sixtFlow:sixtFlow_ca,
      sixtModals:sixtModals_ca,
      discountModals:discountModals_ca,
      myPoints: myPoints_ca,
      trainPlannerFlow:trainPlannerFlow_ca

    },
    fr: {
      global: global_fr,
      home: home_fr,
      header: header_fr,
      resumeroute: resumeroute_fr,
      registerflow: registerflow_fr,
      login:login_fr,
      recoverPasswordFlow:recoverPasswordFlow_fr,
      aveFlow:aveFlow_fr,
      confirmPlani:confirmPlani_fr,
      myPastTrips:myPastTrips_fr,
      myTrips:myTrips_fr,
      onBoarding:onBoarding_fr,
      onBoardingATC:onBoardingATC_fr,
      paymentMethodsFlow:paymentMethodsFlow_fr,
      personalDataProfile:personalDataProfile_fr,
      preferences:preferences_fr,
      privateHome:privateHome_fr,
      tripSelector:tripSelector_fr,
      plannerFlow:plannerFlow_fr,
      assint:assint_fr,
      deleteAccountFlow:deleteAccountFlow_fr,
      userform:userform_fr,
      myCardsTitles:myCardTitles_fr,
      tmbPages:tmbpages_fr,
      tmbConfirmPlanni:tmbConfirmPlanni_fr,
      tmbModals:tmbModals_fr,
      sixtFlow:sixtFlow_fr,
      sixtModals:sixtModals_fr,
      discountModals:discountModals_fr,
      myPoints: myPoints_fr,
      trainPlannerFlow:trainPlannerFlow_fr

    },
    gl: {
      global: global_gl,
      home: home_gl,
      header: header_gl,
      resumeroute: resumeroute_gl,
      registerflow: registerflow_gl,
      login:login_gl,
      recoverPasswordFlow:recoverPasswordFlow_gl,
      aveFlow:aveFlow_gl,
      confirmPlani:confirmPlani_gl,
      myPastTrips:myPastTrips_gl,
      myTrips:myTrips_gl,
      onBoarding:onBoarding_gl,
      onBoardingATC:onBoardingATC_gl,
      paymentMethodsFlow:paymentMethodsFlow_gl,
      personalDataProfile:personalDataProfile_gl,
      preferences:preferences_gl,
      privateHome:privateHome_gl,
      tripSelector:tripSelector_gl,
      plannerFlow:plannerFlow_gl,
      assint:assint_gl,
      deleteAccountFlow:deleteAccountFlow_gl,
      userform:userform_gl,
      myCardsTitles:myCardTitles_gl,
      tmbPages:tmbpages_gl,
      tmbConfirmPlanni:tmbConfirmPlanni_gl,
      tmbModals:tmbModals_gl,
      sixtFlow:sixtFlow_gl,
      sixtModals:sixtModals_gl,
      discountModals:discountModals_gl,
      myPoints: myPoints_gl,
      trainPlannerFlow:trainPlannerFlow_gl

    },
    va:  {
      global: global_va,
      home: home_va,
      header: header_va,
      resumeroute: resumeroute_va,
      registerflow: registerflow_va,
      login:login_va,
      recoverPasswordFlow:recoverPasswordFlow_va,
      aveFlow:aveFlow_va,
      confirmPlani:confirmPlani_va,
      myPastTrips:myPastTrips_va,
      myTrips:myTrips_va,
      onBoarding:onBoarding_va,
      onBoardingATC:onBoardingATC_va,
      paymentMethodsFlow:paymentMethodsFlow_va,
      personalDataProfile:personalDataProfile_va,
      preferences:preferences_va,
      privateHome:privateHome_va,
      tripSelector:tripSelector_va,
      plannerFlow:plannerFlow_va,
      assint:assint_va,
      deleteAccountFlow:deleteAccountFlow_va,
      userform:userform_va,
      myCardsTitles:myCardTitles_va,
      tmbPages:tmbpages_va,
      tmbConfirmPlanni:tmbConfirmPlanni_va,
      tmbModals:tmbModals_va,
      sixtFlow:sixtFlow_va,
      sixtModals:sixtModals_va,
      discountModals:discountModals_va,
      myPoints: myPoints_va,
      trainPlannerFlow:trainPlannerFlow_va
    }
  }
})

// const root = createRoot(document.getElementById('root') as HTMLElement);
// root.render(
//   <React.StrictMode>
//     <I18nextProvider i18n={i18next}>
//       <BrowserRouter basename='/app/'>
//         <RaaSContextProvider>
//           <App />
//         </RaaSContextProvider>
//       </BrowserRouter>
//     </I18nextProvider>
//   </React.StrictMode>
// )


ReactDOM.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18next}>
        <BrowserRouter basename='/app/'>
          <RaaSContextProvider>
            <App />
          </RaaSContextProvider>
        </BrowserRouter>
      </I18nextProvider>
    </React.StrictMode>
  ,
  document.getElementById('root')
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
